export enum TrackStatusType {
    NOT_STARTED = "NOT_STARTED",
    IS_STARTED = "IS_STARTED",
    COMPLETED = "COMPLETED",
    FINISHED = "FINISHED"
}